import ClassNames from "classnames";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";

import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import TodayIcon from "@material-ui/icons/Today";

import { useTranslation } from "react-i18next";
import * as icons from "../../config/Icons";

// const taskList = [
//   {
//     coach_name: "Amy Tan",
//     dashboard_id: 1,
//     no_of_tasks: 12,
//   },
//   {
//     coach_name: "Sophia Wong",
//     dashboard_id: 1,
//     no_of_tasks: 10,
//   },
//   {
//     coach_name: "Anthony Bla",
//     dashboard_id: 1,
//     no_of_tasks: 6,
//   },
//   {
//     coach_name: "Malisingam",
//     dashboard_id: 1,
//     no_of_tasks: 4,
//   },
//   {
//     coach_name: "Badrul Ahmad",
//     dashboard_id: 1,
//     no_of_tasks: 0,
//   },
//   {
//     coach_name: "Amy Tan",
//     dashboard_id: 1,
//     no_of_tasks: 7,
//   },
//   {
//     coach_name: "Sophia Wong",
//     dashboard_id: 1,
//     no_of_tasks: 10,
//   },
//   {
//     coach_name: "Anthony Bla",
//     dashboard_id: 1,
//     no_of_tasks: 6,
//   },
//   {
//     coach_name: "Badrul Ahmad",
//     dashboard_id: 1,
//     no_of_tasks: 0,
//   },
// ];

export default function TaskWidgetCountries({
  taskList,
  itemLabel,
  itemCount,
  linkID,
  nameParam,
  country = false,
  ranking = false,
  ...props
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = url => {
    if (url) {
      history.push(url);
    }
  };

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <div
          className={ClassNames(
            styles.icon,
            props.upcoming && styles.iconUpcoming,
            props.overdue && styles.iconOverdue,
            props.topCountries && styles.iconTopCountries
          )}
        >
          {props.upcoming && <TodayIcon />}
          {props.overdue && <ErrorOutlineIcon />}
          {props.topCountries && <StarBorderIcon />}
        </div>
        <div className={styles.title}>
          {props.upcoming && <span>{t("dashboard.coach.upcomingTask")}</span>}
          {props.overdue && <span>{t("dashboard.coach.overdueTask")}</span>}
          {props.topCountries && (
            <span>{t("dashboard.coach.topCountries")}</span>
          )}
        </div>
      </div>
      <div className={styles.body}>
        {taskList &&
          taskList.map((item, index) => {
            const flagIcon = item[itemLabel] + "FlagIcon";
            return (
              <div
                className={styles.item}
                key={index}
                onClick={() => {
                  if (!ranking && !country)
                    handleClick(
                      `/dashboard/${item[linkID]}?name=${item[nameParam]}`
                    );
                }}
              >
                <div className={styles.name}>
                  {ranking && (
                    <img src={icons[`Top${index + 1}`]} alt={item[nameParam]} />
                  )}
                  {(country || ranking) && (
                    <img src={icons[flagIcon]} alt={item[nameParam]} />
                  )}
                  {item[itemLabel]}
                </div>
                {!ranking && (
                  <div className={styles.number}>{item[itemCount]}</div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
